import { ToastContainer, toast } from "react-toastify";

// import JS files
import { useAuth } from "./context/AuthContext";
import { UserDataProvider } from "./context/UserDataContext";
import Authenticated from "./Authenticated";
import UnAuthenticated from "./UnAuthenticated";

// import others files
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import "../src/styles/share.css";

function App() {
  const { token } = useAuth();
  return token ? (
    <UserDataProvider>
      <ToastContainer rtl={true} style={{ fontFamily: "iransans" }} />
      <Authenticated />
    </UserDataProvider>
  ) : (
    <>
      <ToastContainer rtl={true} style={{ fontFamily: "iransans" }} />
      <UnAuthenticated />
    </>
  );
}

export default App;
